import { lightenHexColor } from '../../utils/colorUtils';

export const CABLE_ICON_OUTLINE = '#6b7280';
export const COPPER_COLOR = '#d38f53';
export const COPPER_SECTION_COLOR = lightenHexColor(COPPER_COLOR);
